interface IdentifierKeys {
  gaProductIdentifierKey: "sku" | "id";
  fbProductIdentifierKey: "sku" | "id";
}

const getIdentifierKeys = (): IdentifierKeys => {
  const {
    public: { gaProductIdentifierKey, fbProductIdentifierKey },
  } = useRuntimeConfig();

  return {
    gaProductIdentifierKey,
    fbProductIdentifierKey,
  } as IdentifierKeys;
};

export const getProductIdentifier = (
    platform: "google" | "facebook",
    options: {
      id: string | number;
      sku: string;
      default?: "sku" | "id";
    }
): string | number => {
  const defaultKeyByPlatform = platform === "facebook" ? "sku" : "id";
  const { default: defaultKey = defaultKeyByPlatform } = options;

  const { gaProductIdentifierKey, fbProductIdentifierKey } = getIdentifierKeys();

  if (platform === "google" && gaProductIdentifierKey) {
    return options[gaProductIdentifierKey];
  }

  if (platform === "facebook" && fbProductIdentifierKey) {
    return options[fbProductIdentifierKey];
  }

  return options[defaultKey];
};
